<template>
	<div class="policylibrary qualityenterprise">
		<leftnav class="fl" mkcode='T' itemcode="B-CYZC">
		</leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title">政策库</span>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">政策库</span>
							<input type="text" placeholder="请输入政策关键词" class="search-input" v-model="kw"
								@keydown="searchenter" />
							<button class="search-btn" @click="getlist()">查询</button>
							<button class="search-btn" @click="routerlinkid('/policy-compare')">政策对比</button>
						</div>
					</div>
					<div class="opport-screen-list1">
						<div class="spage-searchbox ">
							<!-- 省市区筛选 -->
							<cityScreen @getEnterpriseList="cityScreenFun"></cityScreen>
							<dl class="opport-screen bdbe">
								<dt class="fl">级别</dt>
								<dd class="fl">
									<span @click="levelValue = ''" :class="levelValue == '' ? 'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item, index) in levelOptions " :key="'leval' + index"
										@click="levelValue = item.paraValue"
										:class="levelValue == item.paraValue ? 'a-screen current' : 'a-screen'">{{ item.paraName }}</span>
									<video-teaching :type="2"></video-teaching>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">发文机构</dt>
								<dd class="fl">
									<span @click="postingValue = ''" :class="postingValue == '' ? 'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item, index) in postingOptions " :key="'leval' + index"
										@click="postingValue = item.paraValue"
										:class="postingValue == item.paraValue ? 'a-screen current' : 'a-screen'">{{ item.paraName }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">政策标签</dt>
								<dd class="fl">
									<span @click="policyLabelValue = ''" :class="policyLabelValue == '' ? 'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item, index) in policyLabelOptions " :key="'leval' + index"
										@click="policyLabelValue = item.paraValue"
										:class="policyLabelValue == item.paraValue ? 'a-screen current' : 'a-screen'">{{ item.paraName }}</span>
								</dd>
							</dl>
							<!-- <dl class="opport-screen bdbe">
								<dd class="fl">
									<span v-for="(item, index) in policyTypeOptions " :key="'leval' + index"
										@click="policyTypeChose(item)"
										:class="policyTypeValue == item.value ? 'a-screen current' : 'a-screen'">{{ item.label + ' ' + item.num }}</span>
									<span class="policy-short-btn a-screen" @click="sortFun()"><el-icon class="el-icon-sort" :class="orderType == 0 ? '' : 'transform-rotateX180'"></el-icon>默认排序{{ orderType }}</span>
									</dd>	
							</dl> -->
						</div>
					</div>
				</div>
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条【 <span
								class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
					</div>
					<div class="information_content information_box">
						<div class="infornews" :key="i" v-for="(list, i) in pagelist">
							<div @click="routerlinkid('/news', list.id,7)" class="infornews_d">
								<h5 class="title"><span class="fl info_title">{{ list.title }}</span>
								</h5>
								<p class="onlyLine-text color-9f9">{{ list.summary }}</p>
							</div>
							<div class="basefont-nocur fz15 ">
								<el-tag size="small" class="mr-1" v-show="list.level">{{ list.level }}</el-tag>
								<el-tag size="small" class="mr-1" v-show="list.tag">{{ list.tag }}</el-tag>
								<el-tag size="small" class="mr-1" v-show="list.type">{{ list.type }}</el-tag>
							</div>
							<div class="pubilsh_info mt-15">
								<span class="pr-1 inline-block  color-666">{{ list.time }}</span>
								<el-divider direction="vertical"></el-divider>
								<span class="px-1 inline-block  color-666"> {{list.org2 || list.org}}</span>
								<!-- <span class="px-1 inline-block color-666 indtry"><em class="color-999">适用行业：</em>专业技术服务业专用设备制造业仪器仪表制造业;其他制造业;农副..</span> -->
							</div>
						</div>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
						<!-- <p><input type="number" v-model="jumppage"/><span @click="aa()">跳转</span></p> -->
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Result } from 'element-ui';
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'index',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			curWebsite: this.$api.getWebsiteType(),
			title: "产业政策",
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 
			kw: "",
			kwtextsearch:false,
			kwtextsearchtext:'',
			pagelist: [
				{id:1,title:'关于征集《上海市浦东新区创新药械产品目录》(第二批)的通知',publishTime:'2023-2-12',summary:"关于征集《上海市浦东新区创新药械产品目录》(第二批)的通知",categoryText:"区级",tag:'资产补贴'},
				{id:2,title:'政策名称2',publishTime:'2023-2-12',summary:"北极星氢能网获悉，4月16日，内蒙古自治区能源局等部门发布《内蒙古自治区可再生能源制氢产业安全管理办法（试行）》的通知。其中指出：允许在化工园区外建设绿氢项目和制氢加氢一体站。绿氢项目不需取得危险化学品安全生产许可。绿氢加氢",categoryText:"省级",tag:'研发补贴'},
				{id:3,title:'政策名称3',publishTime:'2023-2-12',summary:"北极星氢能网获悉，4月16日，内蒙古自治区能源局等部门发布《内蒙古自治区可再生能源制氢产业安全管理办法（试行）》的通知。其中指出：允许在化工园区外建设绿氢项目和制氢加氢一体站。绿氢项目不需取得危险化学品安全生产许可。绿氢加氢",categoryText:"国家级",tag:'研发补贴'},
				{id:4,title:'政策名称4',publishTime:'2023-2-12',summary:"北极星氢能网获悉，4月16日，内蒙古自治区能源局等部门发布《内蒙古自治区可再生能源制氢产业安全管理办法（试行）》的通知。其中指出：允许在化工园区外建设绿氢项目和制氢加氢一体站。绿氢项目不需取得危险化学品安全生产许可。绿氢加氢",categoryText:"区级",tag:'研发补贴'},
				{id:5,title:'政策名称5',publishTime:'2023-2-12',summary:"北极星氢能网获悉，4月16日，内蒙古自治区能源局等部门发布《内蒙古自治区可再生能源制氢产业安全管理办法（试行）》的通知。其中指出：允许在化工园区外建设绿氢项目和制氢加氢一体站。绿氢项目不需取得危险化学品安全生产许可。绿氢加氢",categoryText:"市级",tag:'研发补贴'},
				{id:6,title:'政策名称6',publishTime:'2023-2-12',summary:"北极星氢能网获悉，4月16日，内蒙古自治区能源局等部门发布《内蒙古自治区可再生能源制氢产业安全管理办法（试行）》的通知。其中指出：允许在化工园区外建设绿氢项目和制氢加氢一体站。绿氢项目不需取得危险化学品安全生产许可。绿氢加氢",categoryText:"市级",tag:'研发补贴'},
			],
			levelOptions: [],
			levelValue: '',
			postingOptions: [],
			postingValue: '',
			policyLabelOptions: [],
			policyLabelValue: '',
			policyTypeOptions: [],
			policyTypeValue: '',
			orderType:0,
		}
	},

	beforeCreate() {
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.userdata = this.getuseriformation();
	},
	mounted() {
		// this.init();
	 },
	methods: {
		init(){
			this.getClassify().then((res)=>{
				if(res.data.success){
					this.getlist();
				}
			});
		},
		//获取分类
		getClassify() {
			this.bus.$emit('loading', true);
			return new Promise((resolve, reject) => {
				let ajaxurl = this.$api.common.parameter.list()+"?categoryId=-1";
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then((res) =>{
					console.log("获取筛选分类", ajaxurl, res);
					if(res.data.success){
						let result = res.data;
						this.levelOptions = result.list[0].children || [];
						this.policyTypeOptions = result.list[1].children || [];
						this.policyLabelOptions = result.list[2].children || [];
						this.postingOptions = result.list[3].children || [];
						resolve(res);
					}else{
						reject(res);
					}
				this.bus.$emit('loading', true);
				}).catch(function (error) {
					reject(error);
					// 请求失败处理 console.log(error);
				});
			});
		},
		//点击排序
		sortFun(){
			this.orderType = this.orderType == 0 ? 1 : 0;
			console.log('点击排序');
		},
		//选择申报通知的点击事件，判断再次点击取消筛选
		policyTypeChose(item){
			if(this.policyTypeValue == item.value){
				this.policyTypeValue = '';
			}else{
				this.policyTypeValue = item.value; 
			}
		},
		//省份城市选择 
		cityScreenFun(pid, cid, cuid) {
			this.cityid = cid;
			this.countyid = cuid;
			this.provinceid = pid;
			this.getlist();
		},
		getlist(pages) {
			console.log('请求接口');
			let ajpage = 1;
			pages ? this.page = pages : this.page = 1;
			let province = this.splicing('province', this.provinceid);
			let city = this.splicing('city', this.cityid);
			let levelId = this.splicing('levelId', this.levelValue);
			let typeId = this.splicing('typeId', this.policyTypeValue);
			let orgId = this.splicing('orgId', this.postingValue);
			let tagId = this.splicing('tagId', this.policyLabelValue);
			let kwja = this.splicing('kw', this.kw);
			this.bus.$emit('loading', true);
			let ajaxurl = this.$api.common.policy.list() +'?page='+ajpage + province + city + levelId + typeId + orgId + tagId+kwja;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then((res)=> {
				console.log("政策列表", ajaxurl, res);
				if (res.data.success ) {
					this.pagelist = res.data.list;
					this.totalPage = res.data.totalPage;
					this.pageSize = res.data.pageSize;
					this.total = res.data.totalRecord; 
					this.kwtextsearch = this.kw != "";
					this.kwtextsearchtext = this.kw;
				 } else {

				}
			this.bus.$emit('loading', false);
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		pageHandler: function (page) {
			this.getlist(page);
		},
		//回车搜索
		searchenter(e) {
			if (e.keyCode == 13) {
				this.getlist();
			}
		},
		//搜索关键词
		searchkwfun() {
			this.searchtext = $.trim(this.searchtext);
		},

	},
}
</script>

<style>
.policylibrary  .info_title{
	font-size: 18px;
}
.indtry{
	width: 60%;
	/* text-overflow: ellipsis;
	white-space: normal;
	overflow: hidden; */
}
</style>
